import styled from "styled-components";
import { CenterFlexColumn, FlexColumn, FlexRow } from "styles/layout";

export const BracketRow = styled(FlexRow)`
  align-items: stretch;
`;

const LineColumn = styled(FlexColumn)<{ compact: boolean }>`
  min-width: 45px;
  max-width: 45px;
  padding: 0 5px;
  row-gap: 10px;

  ${({ compact }) =>
    compact && "min-width: 30px; max-width: 30px; padding: 0 1px; "}
`;

export const CenterLineColumn = styled(LineColumn)`
  justify-content: center;
`;

export const StretchLineColumn = styled(LineColumn)``;

export const ShuffleColumn = styled(CenterFlexColumn)`
  min-width: 240px;
  max-width: 240px;
  row-gap: 12px;
`;

export const NodeColumn = styled(CenterFlexColumn)`
  min-width: 200px;
  max-width: 200px;
  row-gap: 10px;
`;

export const GapColumn = styled(CenterFlexColumn)<{ compact: boolean }>`
  min-width: 300px;
  max-width: 300px;
  padding: 0 5px;
  row-gap: 10px;

  ${({ compact }) =>
    compact && "min-width: 262px; max-width: 262px; padding: 0 1px; "}
`;

export const BracketRoundHeader = styled.div<{ isLower: boolean }>`
  background: seagreen;
  filter: grayscale(0.4);
  font-weight: 500;
  color: white;
  width: 206px;
  text-align: center;
  height: 22px;
  margin-bottom: 5px;
  font-size: 11pt;

  ${({ isLower }) => isLower && "margin-top: 20px"}
`;

export const MatchSizedGap = styled.div`
  height: 70px;
`;
